import { ShieldAlert } from "lucide-react";
import Button from "@/components/ui/Button";

interface Props {
  onBack: () => void;
  onKyc: () => void;
}

export default function KycRequiredBlock({ onBack, onKyc }: Props) {
  return (
    <div className="flex w-full flex-col items-center px-4 py-8">
      <div className="w-full max-w-[520px] rounded-[10px] border border-line bg-card p-8 text-center shadow-card">
        <div className="mx-auto flex h-[72px] w-[72px] items-center justify-center rounded-full bg-warning-bg">
          <ShieldAlert className="h-9 w-9 text-warning" />
        </div>
        <h1 className="mt-5 text-xl font-semibold text-ink">KYC verification required</h1>
        <p className="mx-auto mt-2 max-w-[360px] text-sm text-ink-secondary">
          You need to complete and get your KYC approved before creating mandates.
        </p>
        <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
          <Button variant="secondary" onClick={onBack}>
            Back to Dashboard
          </Button>
          <Button onClick={onKyc}>Complete KYC</Button>
        </div>
      </div>
    </div>
  );
}